"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
var opcode_function_1 = require("./opcode-function");
// @ts-ignore
var parser_1 = require("./parser");
function executeScript(input, script) {
    var opCodes = (0, parser_1.parse)(script);
    return evaluateOpCodes([input], opCodes);
}
exports["default"] = executeScript;
function evaluateOpCodes(context, opCodes, callback) {
    do {
        var opCode = opCodes.shift();
        if (opCode == null) {
            throw new Error('null opcode, cannot continue');
        }
        switch (opCode.op) {
            case 'current_context':
                break;
            case 'literal':
                context = [opCode.value];
                break;
            case 'pick':
                context = evaluateOpCode_pick(context, opCode);
                break;
            case 'index':
                context = evaluateOpCode_index(context, opCode);
                break;
            case 'slice':
                context = evaluateOpCode_slice(context, opCode);
                break;
            case 'explode':
                context = evaluateOpCode_explode(context, opCode, callback);
                break;
            case 'create_array':
                context = evaluateOpCode_create_array(context, opCode);
                break;
            case 'create_object':
                context = evaluateOpCode_create_object(context, opCode, callback);
                break;
            case 'pipe':
                context = evaluateOpCode_pipe(context, opCode, callback);
                break;
            case 'function':
                context = (0, opcode_function_1.evaluateOpCode_function)(context, opCode);
                break;
            default:
                // @ts-expect-error if this doesn't error, then some opcode isn't handled
                throw new Error('Unknown op code: ' + opCode.op);
        }
    } while (opCodes.length > 0);
    return context.length > 1 ? context : context[0];
}
function evaluateOpCode_pick(context, opCode) {
    return context.reduce(function (result, each) {
        var _a;
        if (typeof each !== 'object' || Array.isArray(each)) {
            if (opCode.strict) {
                throw new Error("Cannot index ".concat(typeof each, " with ").concat(opCode.key));
            }
            // Skip this value entirely
            return result;
        }
        var picked = (_a = each === null || each === void 0 ? void 0 : each[opCode.key]) !== null && _a !== void 0 ? _a : null;
        result.push(picked);
        return result;
    }, []);
}
function evaluateOpCode_index(context, opCode) {
    return context.reduce(function (result, each) {
        if (!Array.isArray(each)) {
            if (opCode.strict) {
                throw new Error('Can only index into arrays');
            }
            return result;
        }
        var indexed;
        if (Math.abs(opCode.index) > each.length || opCode.index === each.length) {
            indexed = null;
        }
        else if (opCode.index < 0) {
            indexed = each.slice(opCode.index)[0];
        }
        else {
            indexed = each[opCode.index];
        }
        result.push(indexed);
        return result;
    }, []);
}
function evaluateOpCode_slice(context, opCode) {
    return context.reduce(function (result, each) {
        if ('string' !== typeof each && Array.isArray(each) == false) {
            if (opCode.strict) {
                throw new Error('Cannot slice ' + typeof each);
            }
            return result;
        }
        else {
            if (undefined === opCode.start && undefined === opCode.end) {
                throw new Error('Cannot slice with no offsets');
            }
            if (each == null) {
                result.push(null);
            }
            else {
                result.push(each.slice(opCode.start, opCode.end));
            }
            return result;
        }
    }, []);
}
function evaluateOpCode_explode(context, opCode, callback) {
    context = context.reduce(function (result, each) {
        if (Array.isArray(each)) {
            return result.concat(each);
        }
        else if (typeof each === 'object' && each != null) {
            return result.concat(Object.values(each));
        }
        if (opCode.strict) {
            // jq throws an error specifically for `null`, so let's
            // distinguish that from `object`.
            var type = each === null ? 'null' : typeof each;
            throw new Error('Cannot iterate over ' + type);
        }
        return result;
    }, []);
    if (callback) {
        callback(context.length);
    }
    return context;
}
function evaluateOpCode_create_array(context, opCode) {
    return [
        opCode.values.reduce(function (result, opCodesForIndex) {
            var exploder = makeExploder();
            // Array creation terminates an explode chain - all generated
            // results will get collected in the singular array. As such,
            // no parent is called to makeExploderCb, and none is taken by
            // this function.
            var values = evaluateOpCodes(context, __spreadArray([], opCodesForIndex, true), makeExploderCb(exploder));
            if (!exploder.exploded) {
                result.push(values);
            }
            else {
                switch (exploder.length) {
                    case 0:
                        break;
                    case 1:
                        result.push(values);
                        break;
                    default:
                        result = result.concat(values);
                }
            }
            return result;
        }, []),
    ];
}
function evaluateOpCode_create_object(context, opCode, callback) {
    var jsonObject = opCode.entries.reduce(function (result, each) {
        var exploder = makeExploder();
        var values = evaluateOpCodes(context, __spreadArray([], each.value, true), makeExploderCb(exploder, callback));
        if (!exploder.exploded) {
            result[each.key] = [values];
        }
        else {
            switch (exploder.length) {
                case 0:
                    result[each.key] = [];
                    break;
                case 1:
                    result[each.key] = [values];
                    break;
                default:
                    result[each.key] = values;
                    break;
            }
        }
        return result;
    }, {});
    var ops = Object.entries(jsonObject);
    return evaluateOpCode_create_object_build({}, ops);
}
function evaluateOpCode_create_object_build(current, ops) {
    var result = [];
    var op = ops.shift();
    if (op == null) {
        throw new Error('Unexpectedly ran out of ops');
    }
    var key = op[0], values = op[1];
    values.forEach(function (value) {
        current[key] = value;
        if (ops.length > 0) {
            result = result.concat(evaluateOpCode_create_object_build(__assign({}, current), __spreadArray([], ops, true)));
        }
        else {
            result.push(__assign({}, current));
        }
    });
    return result;
}
function evaluateOpCode_pipe(context, opCode, callback) {
    var exploder = makeExploder();
    var result = evaluateOpCodes(context, __spreadArray([], opCode["in"], true), makeExploderCb(exploder, callback));
    if (!exploder.exploded) {
        result = evaluateOpCodes([result], __spreadArray([], opCode.out, true));
    }
    else {
        var explodedResult = void 0;
        switch (exploder.length) {
            case 0:
                explodedResult = [];
                break;
            case 1:
                explodedResult = [result];
                break;
            default:
                explodedResult = result;
                break;
        }
        result =
            explodedResult == null
                ? null
                : explodedResult.map(function (each) { return evaluateOpCodes([each], __spreadArray([], opCode.out, true)); });
    }
    return Array.isArray(result) ? result : [result];
}
function makeExploder() {
    return { exploded: false, length: 0 };
}
function makeExploderCb(exploder, callback) {
    return function (length) {
        exploder.exploded = true;
        exploder.length = length;
        if (callback) {
            callback(length);
        }
    };
}
